<template>
  <div>
    <template v-if="count">
      <div v-for="v in list" :key="`voucher-add-record-${v.id}`" class="item-box">
        <div class="item-content border-bottom">
          <div class="record-list-item flex-justify-between">
            <div class="record-list-title">
              <router-link :to="RouteConfig.voucherDetail.to(v.voucher_id)" class="primary-color">{{ v.voucher_type_name }}</router-link>
            </div>
            <div class="time accent-color">{{ v.add_time | timeToYmdHi }}</div>
          </div>
          <div class="record-list-item">
            代金券 ID：<span class="success-color user-select">{{ v.voucher_id }}</span>；
            面额：<span class="danger-color bolder">{{ v.amount_in_cents | toYuan }}</span> 元；
            <template v-if="v.expire_time && !v.valid_duration_seconds">有效时长：<span class="success-color">{{ v.expire_time | timeToYmdHi }} 过期</span>；</template>
            <template v-else>有效时长：<span class="success-color">{{ v.valid_duration_seconds | formatDuration }}</span>；</template>
            过期时间：<span class="success-color">{{ v.expire_time | timeToYmdHi }}</span>；
            唯一性：<span class="success-color">{{ v.is_unique === 1 ? '每人限领一张' : '可重复拥有' }}</span>；
            发放方式：<span class="success-color">{{  findVoucherIssueType(v.issue_type)[0].name }}</span>；
            备注文件：「<template v-if="v.remark_files && v.remark_files.length"><template v-for="(f, k) in v.remark_files"><a :key="`remark-thumb-${k}`" class="remark-inline-link" :href="f.file_url" target="_blank" :title="f.file_name || f.file_url"><img class="remark-inline-thumb" :src="f.file_url" alt=""></a></template></template><span v-else class="info-color">未上传</span>」。
          </div>
          <div class="store-name accent-color">
            <span class="operator">办理人：{{ v.add_administrator_nickname || '未知管理员' }}</span>
            办理门店：{{ v.store_name }}
          </div>
        </div>
      </div>

      <div v-if="count" class="pagination-box">
        <el-pagination
          :background="true"
          :current-page.sync="page"
          :page-size.sync="size"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="pageSizes"
          :total="count"
          @size-change="handlePageChange"
          @current-change="handlePageChange"
        />
      </div>
    </template>
    <div v-else class="empty-tip">暂无代金券办理记录</div>
  </div>
</template>

<script>
import RouteConfig from '@/router/config';
import { index } from '@/api/voucher-add-record';
import { findVoucherIssueType } from '@/enums/voucherIssueTypes';

export default {
  name: 'VPageVoucherAddRecord',
  props: {
    studentId: Number,
  },
  data: () => ({
    RouteConfig,
    count: 0,
    list: [],
    page: 1,
    size: 10,
    pageSizes: [10, 20, 30],
  }),
  methods: {
    findVoucherIssueType,
    async getList() {
      const params = {
        student_id: this.studentId,
        page: this.page,
        size: this.size,
      };
      const { isError, data } = await index(params);
      if (isError) return;

      this.count = data.count || 0;
      this.list = data.list || [];
    },
    handlePageChange() {
      this.getList();
    },
  },
  beforeMount() {
    this.getList();
  },
};
</script>

<style src="@/components/student-detail-record.css" scoped/>
<style scoped>
.remark-inline-link {
  display: inline-block;
  margin-right: 4px;
}

.remark-inline-thumb {
  width: 36px;
  height: 36px;
  vertical-align: middle;
  border: 1px solid #ebeef5;
  border-radius: 3px;
  object-fit: cover;
}
</style>
